import { render, staticRenderFns } from "./GoodsDetail.vue?vue&type=template&id=3da9f061&scoped=true&"
import script from "./GoodsDetail.vue?vue&type=script&lang=js&"
export * from "./GoodsDetail.vue?vue&type=script&lang=js&"
import style0 from "./GoodsDetail.vue?vue&type=style&index=0&id=3da9f061&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da9f061",
  null
  
)

export default component.exports